import { get, chain, find, reduce, set, isObject } from "lodash"
import { createSelector } from "reselect"
import { getSelectedView } from "./assets"
import { escapeContentSetId } from "helpers/contentSet"

const EMPTY_ARRAY = []
const EMPTY_OBJECT = {}

export const getContentSets = state => get(state, "global.data.contentSets.data.contentSets", EMPTY_ARRAY)
const getRawContentSetCategories = state => get(state, "global.data.selectedContentSetCategories.data.contentSet.categories", EMPTY_ARRAY)
const getSelectedContentSetCategoriesQueryId = state => get(state, "global.data.selectedContentSetCategories.id")
const getParamsContentSet = (state, props) => get(props, "params.contentSetId")

export const getContentSetsFactors = createSelector(
  [getContentSets],
  (contentSets) => chain(contentSets).groupBy((contentSet) => contentSet.id).mapValues((contentSet) => get(contentSet, "0.factors")).value(),
)

const getSelectedContentSet = createSelector(
  [getSelectedView, getParamsContentSet, getContentSets],
  (selectedView, selectedContentSet, contentSets) => find(contentSets, ({ id }) => (selectedContentSet ?? selectedView) === id),
)

export const getSelectedViewIsContentSet = createSelector(
  [getSelectedContentSet],
  isObject,
)

export const getCategoriesForCurrentContentSet = createSelector(
  [getRawContentSetCategories, getSelectedContentSetCategoriesQueryId, getSelectedView],
  (categories, selectedContentSetCategoriesQueryId, contentSetId) => {
    if (!selectedContentSetCategoriesQueryId || selectedContentSetCategoriesQueryId !== `selectedContentSetCategories-${contentSetId}`) {
      return EMPTY_ARRAY
    }
    return categories
  },
)

export const getSelectedContentSetCategories = createSelector(
  [getCategoriesForCurrentContentSet],
  (categories) => {
    if (!categories || categories.length === 0) return EMPTY_OBJECT
    return reduce(categories, (allFactors, category) => set(allFactors, category.id, {
      ...category,
      factors: reduce(category.factors, (factorsById, factor) => set(factorsById, factor.id, { label: factor.name, category: category.id }), {}),
    }), {})
  },
)

export const getSortedContentSets = createSelector(
  [getContentSets],
  (contentSets) => chain(contentSets)
    .sortBy("name")
    .map(contentSet => ({
      escapedId: escapeContentSetId(contentSet.id),
      ...contentSet,
    }))
    .value(),
)

export const getSelectedContentSetDataType = createSelector(
  [getSelectedContentSet],
  (selectedContentSet) => get(selectedContentSet, "dataType", null),
)
